export default {
    locale: 'ja-JP',
    language: '日语',
    menu: {
        i18n: '多言語'
    },
    page: {
        login: {
            title: 'サインイン',
            remember: '自動ログイン',
            forgot: 'パスワードを忘れた',
            submit: 'サインイン',
            other: 'その他のログイン方法',
            signup: '注册账户'
        },
        register: {
            title: '注册',
            submit: '注册',
            other: '使用已有账户登录'
        },
        exception: {
            e403: 'ごめんなさい，このページにアクセスする権限がありません',
            e404: 'ごめんなさい，アクセスしたページは存在しません',
            e500: 'ごめんなさい，サーバーエラー',
            btn: 'ホームに戻る'
        },
        i18n: {
            content: '你好，很高兴认识你！'
        }
    }
}
